import { render, staticRenderFns } from "./pTrain.vue?vue&type=template&id=91f9de66"
import script from "./pTrain.vue?vue&type=script&lang=js"
export * from "./pTrain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports